import http from '../utils/http';

const URL_BASE = 'rastreabilidade/fabrica';

const mapDetalheFabrica = (payload = {}) => {
    const di = payload.dadosIndustria || {};
    const loc = payload.localidade || {};
    return {
        registroIndustrial: di.numeroRegistro ?? null,
        ruc: di.ruc ?? di.RUC ?? null,
        idLyra: di.idLyra ?? null,
        razaoSocial: di.razaoSocial ?? null,
        departamento: loc.departamento ?? null,
        distrito: loc.distrito ?? null,
        endereco: loc.direcao ?? null,
        latitude: loc.latitude ?? null,
        longitude: loc.longitude ?? null
    };
};

export default {

    async getFactoryInformation(id) {
        const res = await http.get({
            url: `${URL_BASE}/${id}`,
            lockScreen: false
        });
        return { data: mapDetalheFabrica(res.data) };
    },
    async getFactoryTotalizers(id) {
        const res = await http.get({
            url: `${URL_BASE}/${id}/totalizadores`,
            lockScreen: false
        });

        return { data: res.data };
    },
    async getFactoryOperations(id, page, size, filters = {}) {
        const res = await http.post({
            url: `${URL_BASE}/${id}/transacoes?page=${page}&size=${size}`,
            data: { ...filters},
            lockScreen: false
        });

        return { data: res.data };
    },
    getFactoryTerritories(id, page, size) {
        return http.get({
            url: `${URL_BASE}/${id}/territorios?page=${page}&size=${size}`,
            lockScreen: false
        });
    }
};
